export const liveGalleryPath = "/live";

export function shouldRenderLiveGallery(pathname: string) {
  return pathname.replace(/\/+$/, "") === liveGalleryPath;
}
